import React from "react";
import * as S from "./JourneyHeader.style";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import { useNavigate } from "react-router-dom";

const JourneyHeader = ({ patient }) => {
  const navigate = useNavigate();

  return (
    <S.Container>
      <div className="left-side">
        <button className="close-btn" >
          <i className="icon zaia-icono-cerrar" />
        </button>
        <span className="title">Cerrar <strong>Journey de paciente</strong></span>
      </div>

      {patient && (
        <div className="right-side">
          <div className="patient-info">
            <ZaiaImage 
              img={patient.img} 
              alt={patient.name} 
              size={39} 
              rounded 
            />
            <div className="texts">
              <span className="name">{patient.name}</span>
              <span className="condition">{patient.condition}</span>
            </div>
          </div>
          
          <div className="status-badge">
            <div className="status-badge__icon">
              <i className="icon zaia-i-refresh" />     
            </div>
            <div className="status-main">
              <div className="status-main__text">
                En control
                <div className="status-sub">
                  En tratamiento activo
                </div>
              </div>
              <div className="status-badge__date">
                Desde {"13 de Julio 2026"}
              </div>
            </div>
          </div>
        </div>
      )}
    </S.Container>
  );
};

export default JourneyHeader;
